__turbopack_context__.v({
  "closeButton": "notification-alerts-module__Ar9JBq__closeButton",
  "description": "notification-alerts-module__Ar9JBq__description",
  "icon": "notification-alerts-module__Ar9JBq__icon",
  "root": "notification-alerts-module__Ar9JBq__root",
  "title": "notification-alerts-module__Ar9JBq__title",
});
